const state = {
    edit_account: {},
    ftp_accounts: [],
    add_ftp_account: false,
};

const getters = {};

const actions = {
    getFtpAccountsForDomain({ commit }, domainId) {
        return new Promise((resolve, reject) => {
            let ftpAccounts = [];
            let r = this._vm.$laroute.route("domain_ftp", { domain_id: domainId });
            this._vm.$axios
                .get(r)
                .then((response) => {
                    if (response.data.call_status === "OK") {
                        for (let account of response.data.data) {
                            ftpAccounts.push({...account, beingEdited: '0'});
                        }

                        commit('setFtpAccounts', ftpAccounts);
                        resolve(JSON.parse(JSON.stringify(ftpAccounts)));
                    } else {
                        reject(response.data);
                    }
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {});
        });
    },

    addFtpAccount({ commit, rootState }, payload) {
        return new Promise((resolve, reject) => {
            this._vm.$axios
                .post(
                    this._vm.$laroute.route("domain_ftp_store", {
                        domain_id: rootState.environments.rootDomainId,
                    }),
                    {
                        path: payload.path,
                        username: payload.username,
                        password: payload.password,
                        description: payload.description,
                        env_id: rootState.environments.domainId,
                    }
                )
                .then((response) => {
                    if (response.data.call_status === "FAILED") {
                        reject("addFtpAccount - " + response.data.error);
                    } else {
                        //commit("addFtpAccount", { env_name: payload.env_name, id: response.data.new_dev });
                        commit("addFtpAccount", { path: payload.path, username: payload.username, password: payload.password, description: payload.description, beingEdited: '0' });
                        resolve();
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    deleteFtpAccount({ commit, rootState }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('domain_ftp.delete_account', {
                domain_id: request_data['domain_id'],
                ftp_account_id: request_data['ftp_account_id']
            });
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    updateFtpAccount({ commit, rootState }, payload) {
        return new Promise((resolve, reject) => {
            this._vm.$axios
                .post(
                    this._vm.$laroute.route("domain_ftp.update_account", {
                        domain_id: rootState.environments.rootDomainId,
                    }),
                    {
                        account_id: payload.account_id,
                        new_path: payload.path,
                        new_username: payload.username,
                        new_password: payload.password,
                        new_description: payload.description,
                        env_id: rootState.environments.domainId,
                    }
                )
                .then((response) => {
                    if (response.data.call_status === "FAILED") {
                        reject("updateFtpAccount - " + response.data.error);
                    } else {
                        commit("updateFtpAccount", payload);
                        resolve();
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

const mutations = {
    setEditAccount(state, value){
        if(value.beingEdited !== '1')
        {
            state.ftp_accounts.forEach((account) => {
                account.beingEdited = '0';
            });

            value.beingEdited = '1';
            state.edit_account = value;
        }
        else
        {
            value.beingEdited = '0';
        }
    },

    unsetEditAccount(state){
        state.ftp_accounts.forEach((account) => {
            account.beingEdited = '0';
        });

        state.edit_account = {};
    },

    setFtpAccounts(state, value){
        state.ftp_accounts = value;
    },

    unsetFtpAccount(state, value){
        state.ftp_accounts.splice(value, 1);
    },

    updateFtpAccount(state, value){
        state.ftp_accounts.forEach((account) => {
            if(account.id === value.account_id)
            {
                account.path = value.path;
                account.username = value.username;
                account.paswword = value.paswword;
                account.description = value.description;
                account.beingEdited = '0';
            }
        });
    },

    setAddFtpAccount(state, value){
        if(value === true && state.add_ftp_account === true)
        {
            state.add_ftp_account = false;
        }
        else
        {
            state.add_ftp_account = value;
        }
    },

    addFtpAccount(state, value){
        state.ftp_accounts.push(value);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
